import { render, staticRenderFns } from "./OrgConferenceList.vue?vue&type=template&id=2fc11143&scoped=true"
import script from "./OrgConferenceList.vue?vue&type=script&lang=js"
export * from "./OrgConferenceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc11143",
  null
  
)

export default component.exports